import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/auth/login",
  },
  {
    path: "/auth/login",
    name: "Login",
    component: () => import("../views/authentication/login.vue"),
    props: true,
  },
  {
    path: "/auth/forgot",
    name: "Forgot Password",
    component: () => import("../views/authentication/forgot.vue"),
    props: true,
  },
  {
    path: "/auth/reset",
    name: "Reset Password",
    component: () => import("../views/authentication/reset.vue"),
    props: true,
  },
  {
    path: "/timesheets/:doctorId",
    name: "Home",
    component: () => import("../views/timesheets/index.vue"),
    props: true,
  },
  {
    path: "/timesheets/success/:doctorId",
    name: "Success",
    component: () => import("@v/timesheets/success.vue"),
    props: true,
  },
  {
    path: "/bonus",
    name: "Bonus Retainer Tracking",
    component: () => import("@v/bonus/index.vue"),
    props: true,
  },
  {
    path: "/reports",
    name: "Reports",
    component: () => import("@v/reports/index.vue"),
    props: true,
  },
  {
    path: "/documents",
    name: "Documents",
    component: () => import("@v/documents/index.vue"),
    props: true,
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/admin/menu.vue"),
    props: true,
    children: [
      {
        path: "bonus",
        name: "Admin - Bonus Retainer Tracking",
        component: () => import("../views/admin/bonus/index.vue"),
        props: true,
      },
      {
        path: "doctors",
        name: "Admin - Doctors",
        component: () => import("../views/admin/doctors/index.vue"),
        props: true,
      },
      {
        path: "locations",
        name: "Admin - Locations",
        component: () => import("../views/admin/locations/index.vue"),
        props: true,
      },
      {
        path: "users",
        name: "Admin - Users",
        component: () => import("../views/admin/users/index.vue"),
        props: true,
      },
      {
        path: "reports",
        name: "Admin - Reports",
        component: () => import("../views/admin/reports/index.vue"),
        props: true,
      },
      {
        path: "documents",
        name: "Admin - Documents",
        component: () => import("../views/admin/documents/index.vue"),
        props: true,
      },
      {
        path: "integrations",
        name: "Admin - Integrations",
        component: () => import("../views/admin/integrations/index.vue"),
        props: true,
      },
      {
        path: "/users/settings",
        name: "Change Password",
        component: () => import("../views/users/change-password.vue"),
        props: true,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
